import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=56bcbaf9&"
import script from "./ThankYou.vue?vue&type=script&lang=js&"
export * from "./ThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bcbaf9')) {
      api.createRecord('56bcbaf9', component.options)
    } else {
      api.reload('56bcbaf9', component.options)
    }
    module.hot.accept("./ThankYou.vue?vue&type=template&id=56bcbaf9&", function () {
      api.rerender('56bcbaf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ThankYou.vue"
export default component.exports